import OfferCard from '../../data/models/OfferCard'


export default ({ title, offers, __typename }) => ({
  __typename,
  title,
  cards: offers?.map(OfferCard),
})
